
import Vue from "vue";
import UIFeatureMixin from "@/mixins/UIFeatureMixin.vue";
import ImageOverContent from "@/components/common/ImageOverContent.vue";

export default Vue.extend({
  name: "trans-prog-overview-content",
  components: { ImageOverContent },
  mixins: [UIFeatureMixin],
});
